import { SearchTransferResponse, TransferOption } from './transfer.interfaces';
import { convertToDate } from '@shared/helpers/datetime/datetime';
import { TransferExtra } from '../Cart/cart.interfaces';
import { getLoremIpsum } from '@shared/utils/lorem';
import hoppaJSON from './transfer.hoppa.json';

function mapToTransferOption(data: any, index: number): TransferOption {
    return {
        Id: data.Id,
        Duration: data.Duration,
        OptionSeats: data.OptionSeats,
        Price: data.Price,
        FreeCancelUntil: data.FreeCancelUntil ? new Date(data.FreeCancelUntil) : null,
        Extras: data.Extras.map(
            (extra: any) =>
                ({
                    Id: extra.Id,
                    Price: {
                        Amount: parseFloat(extra.Price.Amount),
                        Currency: extra.Price.Currency,
                    },
                    Type: extra.Type,
                    MaxCount: parseInt(extra.MaxCount, 10),
                    Count: extra.Count,
                    Description: extra.Description,
                }) as TransferExtra
        ),
        MaxLargeLuggage: data.Luggage,
        Distance: data.Distance,
        TollsIncluded: data.TollsIncluded,
        GratuityIncluded: data.GratuityIncluded,
        DriverWaitingTime: data.DriverWaitingTime,
        TransferVehicle: data.TransferVehicle,
        TransferPartner: data.TransferPartner,
        CancellationPolicyText: data.CancellationPolicyText,
        TransferType: data.TransferType,
        SupplierPrice: data.Price,
        IsSharedTransfer: data.IsSharedTransfer,
        ...getDisclaimer(index),
    };
}

const getDisclaimer = (index: number) => {
    return {
        DisclaimerTitle: index % 2 === 0 ? 'Child and Baby Seat requirements in Spain' : null,
        DisclaimerDescription: index % 3 === 0 ? getLoremIpsum(4) : null,
    };
};

const getFakeData = (): SearchTransferResponse => {
    return {
        StartTime: convertToDate(hoppaJSON.StartTime),
        Options: hoppaJSON.Options.map((data, index) => mapToTransferOption(data, index)),
    };
};

export const fakeTransferData: SearchTransferResponse = getFakeData();
